// extracted by mini-css-extract-plugin
export default {"container":"SportCardHeader_container__ZO6za","wrapper":"SportCardHeader_wrapper__Ln7eq","scoreBoard":"SportCardHeader_scoreBoard__VRXyW"};